import React from 'react';
import '../../styles/SolucionesPublicitarias.css';

const EmailMkt = () => {
    return (
        <section className="email-mkt-add-section py-5">
            <div className="container">
                <div className='row justify-content-center align-items-center m-1'>
                    <div className='col-lg-4 col-md-12 col-1-email-mkt mt-5'>
                        <div className='pb-2' data-aos="fade-up">
                            <h2 className="title"><span>Email </span>MKT</h2>
                        </div>

                        <div className='pb-2' data-aos="fade-up">
                            <p>
                                Nuestro eBlast es más que un simple newsletter: Es una herramienta estratégica para
                                destacar tu marca como sponsor principal en una comunicación de alto impacto. Diseñamos
                                contenido específico con storytelling, asegurando mensajes coherentes y relevantes que
                                resuenen con tu audiencia.
                            </p>
                            <p>
                                Cada envío se segmenta cuidadosamente a nuestras bases exclusivas y curadas, conectando
                                con personas que comparten intereses alineados con tu marca y logrando resultados medibles.
                            </p>
                        </div>

                    </div>
                    <div className='col-lg-8 col-md-12 text-center mt-5'>
                        <div className='d-flex align-items-end justify-content-end'>
                            <div data-aos="zoom-in" data-aos-delay="600">
                                <img src="assets/email-mkt-1.png" alt="" className='img-fluid img-filter' />
                            </div>
                            <div className='ml-2 mx-2' data-aos="zoom-in" data-aos-delay="0">
                                <img src="assets/email-mkt-2.png" alt="" className='img-fluid img-filter' />
                            </div>
                            <div data-aos="zoom-in" data-aos-delay="300">
                                <img src="assets/email-mkt-3.png" alt="" className='img-fluid img-filter' />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default EmailMkt;